import { AutorPoster } from "./participante";
import Evaluacion from "./evaluacion";

/**
 * PP: Propuesta por revisar
 * PA: Propuesta aceptada
 * PR: Propuesta rechazada
 * RPPST: Por evaluar posters
 * RPPNC: Por evaluar ponencia.
 * RD: Propuesta evaluada
 * PRE_PST: Pre-aceptado como poster
 * PRE_PNC: Pre-aceptado como ponencia
 */
enum REVISION {
  PP,
  PA,
  PR,
  RPPST,
  RPPNC,
  RD,
  PRE_PST,
  PRE_PNC,
  A_PNC,
  A_PST,
}

export interface SimplePoster {
  id_poster: number | string;
  id_participante?: number | string;
  titulo: string;
  evento: string;
  tipo: "T" | "I";
  codigo: number | string;
  estado: "P" | "PI" | "A" | "N" | "PR";
  url_video: string | null;
  file: string | null;
  revision: REVISION;
  calificado?: boolean;
  _vp?: boolean;
  index?: number;
  tipo_aceptacion: "PST" | "PNC";
}

export interface Poster extends SimplePoster {
  palabras_claves: string;
  introduccion: string;
  objetivo_general: string;
  metodologia: string;
  resultados: string;
  conclusiones: string;
  autores: AutorPoster[];
  observaciones?: string[];
  evaluacion?: Evaluacion;
}

export const simplePosterKeys: (keyof SimplePoster)[] = [
  "id_poster",
  "titulo",
  "evento",
  "tipo",
  "codigo",
  "estado",
  "url_video",
  "file",
  "revision",
  "_vp",
  "index",
];

export function isModifiablePoster(poster?: SimplePoster | null) {
  return poster ? poster.estado === "P" || poster.estado === "PI" : false;
}

export function needsUpload(poster?: SimplePoster | null) {
  return poster ? poster.estado == "PI" : false;
}

export function mayUpdatePoster(poster?: SimplePoster | null) {
  return poster ? isModifiablePoster(poster) || needsUpload(poster) : false;
}
